import K from '../constants';
import restHelpers from '../helpers/restHelper';

const addFn = ({position, radius, type, title, address}) => restHelpers.withBearer.post(`${K.API_URL}/point-of-interests`, { data: { position, radius, type, title, address } });
const deleteFn = poiId => restHelpers.withBearer.delete(`${K.API_URL}/point-of-interests/${poiId}`);

export default {
  add: addFn,
  delete: deleteFn
};



// WEBPACK FOOTER //
// ./src/services/pois.js